<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="false">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放视唱
        </el-col>
        <el-col :span="24" class="imgStyle" align="left">
            <div class="quImg">
                <img :src="heart.questionDto.detailInfo.questionImgUrl" alt="" srcset="">
            </div>
            <div class="playTheDrums">
                <div class="operationBox" style="left:12%;right:12%">
                    <audio-style 
                        style="width:70%;float:left;margin-left:15%"
                        ref="audioRecording"
                        @startPlaying="startPlayingLuYing"
                        @endPlaying="endPlayingLuYing"
                        @getPlays="getPlaysLuYing"
                        :audioUrl="luYingUrl"
                        class="audioCom"
                    ></audio-style>
                </div>
                <p>请点击播放录制的音频</p>
            </div>
        </el-col>

        <audio ref="tock" :src="tockUrl" v-show="false"></audio>
    </div>
</template>
<script>
import recording from '../../lib/recording'
import audioStyle from '../../components/audioStyle'
import os from '../../lib/oss'
import utils from '../../lib/util'
    export default {
        name:"rhythmChoice",
        props: {
            sonData: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                tockUrl:require('../../../static/music/tock.wav'),
                rhythmBeatVal:[],
                letTime:0,
                sdudent:false,
                timeHer:'',
                recordingType:'go',
                luYingUrl:'',
                timeLz:0,
                interval: '',
                plays:0,
            }
        },
        components:{
            audioStyle
        },
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.plays = utils.mottoClone(this.heart.questionDto.detailInfo.playTime)
            this.$nextTick(function(){
                // 赋值答案
                this.luYingUrl = this.heart.errorObj.rhythmSingAudioUrl
            })
        },
        methods:{
            goRecording(){
                this.mouseStart(this.plays,this.heart.questionDto.detailInfo.playTime)
            },
            endRecording(){
                this.$refs.audioRef.endAudio()
                this.recordingType = 'end'
                this.mouseEnd()
            },
            againRecording(plays,nPlays=-1){
                if(plays>0||nPlays==-1){
                    this.luYingUrl = ''
                    this.recordingType = 'ing'
                    this.mouseStart()
                }else{
                    this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                }
            },
            mouseStart (plays,nPlays=-1) {
                if(plays>0||nPlays==-1){
                    this.clearTimer()
                    this.startTime = new Date().getTime()
                    this.timeLz = 0
                    recording.get((rec) => {
                        // 要获取浏览器的麦克风权限
                        if (rec) {
                            if (this.flag) {
                                this.mouseEnd()
                                this.flag = false
                            } else {
                                this.startAudio()
                                this.recordingType = 'ing'
                                this.recorder = rec
                                this.interval = setInterval(() => {
                                    this.timeLz++
                                    this.recorder.start()
                                }, 1000)
                            }
                        }else{
                            this.$message({showClose: true,message: '请设置您的麦克风访问权限'});
                        }
                    })
                }else{
                    this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                }
            },
            mouseEnd () {
                let that = this
                that.clearTimer()
                that.endTime = new Date().getTime()
                if (that.recorder) {
                    that.recorder.stop()
                    let bold = that.recorder.getBlob()
                    let files = new File([bold], `recording${Date.parse(new Date())}.mp3`, {type: 'audio/mp3', lastModified: Date.now()})
                    os.uploadHttp(files,function(e,file){
                        that.sdudent = false
                        // console.log(e)
                        that.luYingUrl = e
                    })
                }
            },
            clearTimer () {
                if (this.interval) {
                    this.timeLz = 0
                    clearInterval(this.interval)
                }
            },
            getPlays(){
                if(this.$refs.audioRecording)
                this.$refs.audioRecording.endAudio();
                this.$refs.audioRef.fatherPlay(1000)
            },
            startPlaying(){
                this.letTime = 0;
                this.timeHer = setInterval(()=>{
                    this.letTime+=5
                },5)
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
                clearInterval(this.timeHer)
                this.letTime = 0
            },
            getPlaysLuYing(){
                this.$refs.audioRef.endAudio();
                this.$refs.audioRecording.fatherPlay(1000,-1);
            },
            startPlayingLuYing(){},
            endPlayingLuYing(){},
            yesNotProblem(){
                if(this.luYingUrl) return true
                return false
            },
            startAudio(){
                this.$refs.audioRef.goPlay()
                this.endPlaying()
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
                if(this.$refs.audioRecording) this.$refs.audioRecording.endAudio()
                if(this.recordingType == 'ing'){this.endRecording()}
            },
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            height: 92%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .quImg{
                width: 70%;
                height: 100%;
                float: left;
                display: inline-block;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    display: table-cell;
                    vertical-align: middle;
                    align-items: center;
                    max-height: 100%;
                    max-width: 100%;
                }
            }
            .playTheDrums{
                width: 30%;
                height: 100%;
                float: right;
                position: relative;
                .operationBox{
                    position: absolute;
                    left: 28%;
                    right: 25%;
                    top: 52%;
                    height: 10%;
                    max-height: 45px;
                    min-height: 35px;
                }
                .operationGo{
                    height: 100%;
                    background-color: rgb(0, 204, 106);
                    color: #fff;
                    border: 3px solid rgb(207, 255, 232);
                }
                .operationIng{
                    height: 100%;
                    background-color: rgb(204, 0, 0);
                    color: #fff;
                    border: 3px solid rgb(204, 0, 0);
                }
                .operationEnd{
                    width: 45%;
                    height: 33px;
                    background-color: rgb(59,131,252);
                    color: #fff;
                    border: 0px;
                    float: right;
                }
                p{
                    position: absolute;
                    top: 63%;
                    height:15px;
                    left: 0;
                    right: 0;
                    text-align: center;
                    font-size: 12px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/examRecords/rhythmScChoice.vue